import axios from "axios"
import { FormsNewsletterOrderBy, FormsNewsletterService } from "../client"
const API_URL = import.meta.env.VITE_API_URL

/* Interfaces */
export interface DetailNewsletterProps {
  onClose: () => void
  isOpen: boolean
  newsletterId: string
}


/* Endpoints */
export const readFormsNewsletters = ({
    per_page,
    page,
    order_by,
    descending,
    query,
}: {
    per_page: number,
    page: number
    order_by?: FormsNewsletterOrderBy
    descending?: boolean
    query?: string
}) => {
    return {
        queryFn: async () => {
            const data = await FormsNewsletterService.readFormsNewsletters({
                skip: (page - 1) * per_page,
                limit: per_page,
                orderBy: order_by,
                descending: descending,
                query: query,
            })

            return data ?? { data: null, count: 0 }
        },
        queryKey: ["forms-newsletters", { page, order_by, descending, query }],
    }
}

export const readFormsNewsletterById = (newsletterId: string) => {
  return {
    queryFn: async () => {
        const data = await FormsNewsletterService.readFormsNewsletterById({ newsletterId: newsletterId })

        return data ?? { data: null, count: 0 }
    },
    queryKey: ["newsletter", { newsletterId }],
  }
}

export async function exportNewsletter(showToast: any,) {
    try {
        let filename = "export_newsletter.xlsx"
        const bearer = localStorage.getItem("access_token")


        const response = await axios.get(`${API_URL}/v1/reda/forms/newsletter/export`, {
            responseType: "blob",
            headers: {
                Authorization:  `Bearer ${bearer}`
            }
        })
        
        if (response.status === 204) { 
            showToast( "Keine Daten", "Es sind keine aktiven Newslettereinträge zum Exportieren vorhanden.", "warning" )
            return
        }

        const blob = response.data
        const url = window.URL.createObjectURL(blob)
        var a = document.createElement("a")
        a.href = url
        a.download = filename
        document.body.appendChild(a)
        a.click()
        a.remove()

        showToast("Aktion erfolgreich!", "Die Datei wurde heruntergeladen", "success")
    } catch (error) {
        showToast("Fehler", "Die Datei konnte nicht heruntergeladen werden.", "error")
    }
}